const results = [
  'руководители быстрее реагируют на проблемы — сложный разговор проводится сразу, а не через месяц;',
  'сотрудники лучше понимают ожидания — конкретная обратная связь вместо общих фраз;',
  'договорённости становятся конкретнее — каждый разговор завершается планом действий;',
  'снижается количество повторяющихся ошибок — сотрудники знают, что именно нужно изменить;',
  'сложные ситуации не откладываются месяцами — руководители перестают избегать неприятных разговоров;',
  'повышается ответственность сотрудников — они принимают на себя обязательства по изменению;',
  'руководители увереннее проводят неприятные разговоры — появляется инструмент и практический опыт;',
  'конфликты обсуждаются раньше — до того, как они перерастут в серьёзное противостояние;',
  'обратная связь становится регулярной частью управления — не только когда что-то пошло не так;',
  'сотрудники получают больше развивающей обратной связи — не только корректирующую, но и поддерживающую;',
  'управленческие требования становятся понятнее — сотрудники знают правила игры и критерии оценки.',
];

export default function CompanyResults() {
  return (
    <section id="results" className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Что меняется после развития навыков обратной связи
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Возможные результаты для компании, когда руководители системно применяют инструменты обратной связи и сложных разговоров
        </p>

        <div className="grid sm:grid-cols-2 gap-3 max-w-4xl mx-auto">
          {results.map((r, i) => (
            <div key={i} className="flex items-start gap-2.5 bg-white rounded-lg border border-gray-200 p-3 hover:border-teal-300 transition-colors">
              <i className="ri-checkbox-circle-line text-teal-600 mt-0.5 flex-shrink-0"></i>
              <span className="text-sm text-gray-700">{r}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}